import React, { createContext, useState, useEffect, useContext } from "react";

const CartContext = createContext();

export const useCart = () => {
  return useContext(CartContext);
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(
    JSON.parse(sessionStorage.getItem("cart")) || [] // Încărcăm datele din sessionStorage la încărcarea aplicației
  );

  // Sincronizează cart-ul cu sessionStorage
  useEffect(() => {
    sessionStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]); // Aceasta va actualiza sessionStorage de fiecare dată când cart-ul se schimbă

  const updateCartCount = (cartArray) => {
    setCart(cartArray); // Actualizează cart-ul în context
  };

  return (
    <CartContext.Provider value={{ cart, updateCartCount }}>
      {children}
    </CartContext.Provider>
  );
};
